// extracted by mini-css-extract-plugin
export default {"upload":"UploadFileInput_upload__w+pXi","input":"UploadFileInput_input__BubtE"};